export default "__VITE_ASSET__36228238__"